import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { getOpsColor, ROLE_EDITOR } from "../../../utils/helper";
import StyledSelect from "../../StyledSelect/StyledSelect";
import PageOrientation from "../PageOrientation/PageOrientation";
import { StyledBody } from "../SidebarMenu/SidebarMenu-styled";

const DocumentSettings = ({ config, page, dpi, setPage, setDpi, t }) => {
  const activeModule = useSelector((state) => state.activeModule);
  const pageOptions = useMemo(() => {
    const options = [
      {
        label: "A4",
        value: "A4",
      },
      {
        label: "A3",
        value: "A3",
      },
      {
        label: "A2",
        value: "A2",
      },
    ];

    if (config.role === ROLE_EDITOR) {
      options.push({
        label: "A0",
        value: "A0",
      });
    }

    return options;
  }, [config]);

  const onPageSizeChange = useCallback(
    ({ _label, value }) => {
      setPage((prev) => ({
        ...prev,
        size: value,
      }));
    },
    [setPage]
  );

  const onOrientationChange = useCallback(
    (e) => {
      setPage((prev) => ({
        ...prev,
        orientation: e.target.value,
      }));
    },
    [setPage]
  );

  const onDpiChange = useCallback(
    ({ _label, value }) => {
      setDpi(value);
    },
    [setDpi]
  );

  const dpiOptions = useMemo(() => {
    return [
      {
        label: t("print.documentSettings.questions.3.options.print"),
        value: 300,
      },
      {
        label: t("print.documentSettings.questions.3.options.screen"),
        value: 72,
      },
    ];
  }, [t]);

  const selectedDpi = useMemo(() => {
    return dpiOptions.find((item) => item.value == dpi);
  }, [dpiOptions]);

  const opsColor = useMemo(
    () => getOpsColor(config, activeModule),
    [config, activeModule]
  );

  return (
    <StyledBody opsColor={opsColor}>
      <div>
        <p>
          <span>1. </span>
          {t("print.documentSettings.questions.1.title")}
        </p>
        <StyledSelect
          onChange={onPageSizeChange}
          opsColor="var(--opsColor)"
          isSearchable={false}
          defaultValue={{
            label: page.size,
            value: page.size,
          }}
          options={pageOptions}
        />
      </div>
      <div>
        <p>
          <span>2. </span>
          {t("print.documentSettings.questions.2.title")}
        </p>
        <PageOrientation
          selected={page.orientation}
          onInputChange={onOrientationChange}
          opsColor={opsColor}
          t={t}
        />
      </div>
      <div>
        <p>
          <span>3. </span>
          {t("print.documentSettings.questions.3.title")}
        </p>
        <StyledSelect
          onChange={onDpiChange}
          opsColor={opsColor}
          defaultValue={selectedDpi}
          options={dpiOptions}
        />
      </div>
    </StyledBody>
  );
};

export default DocumentSettings;
